module.exports = __webpack_public_path__ + "static/media/СЗФО_2017.91253eed.png";